const getItem = (key) => {
    const data = typeof window !== 'undefined' ? localStorage.getItem(key) : '';
    try {
        return JSON.parse(data);
    } catch (err) {
        return data;
    }
};

const setItem = (key, value) => {
    const stringify = typeof value !== 'string' ? JSON.stringify(value) : value;
    return localStorage.setItem(key, stringify);
};

const removeItem = (key) => {
    localStorage.removeItem(key);
};


const capitalize = (str) => {
    return str ? str.split(/\s+|-|_/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ") : null;
}

export { getItem, setItem, removeItem, capitalize };
